<div *ngIf="actions && actions.length > 0" dropdown autoClose="outsideClick" class="dropdown text-end">
  <div class="booking-options href" for="bookingOptionsMenu">
    <button id="bookingOptionsDropdownToggle" class="btn btn-default" dropdownToggle>
      {{ 'BOOKING_OPTIONS' | translate }}
      <!-- <i class="icon-options"></i> -->
    </button>
  </div>
  <ul
    class="dropdown-menu dropdown-menu-right"
    id="bookingOptionsMenu"
    *dropdownMenu
    role="menu"
    aria-labelledby="split-button"
  >
    <li *ngFor="let action of actions">
      <a [id]="'selectBookingOption_' + action.name" class="href text-nowrap" (click)="selectAction.emit(action)">{{
        action.callToAction
      }}</a>
    </li>
  </ul>
</div>
